<button (click)="openBookMark()" class="notification-box" aria-label="Open Bookmarks">
  <svg>
    <use href="assets/svg/icon-sprite.svg#star"></use>
  </svg>
</button>

<div class="onhover-show-div bookmark-flip" [class.active]="bookmarkFlip || bookmark">
  <div class="flip-card">
    <div class="flip-card-inner" [class.flipped]="bookmarkFlip">
      <div class="front">
        <h6 class="f-18 mb-0 dropdown-title">Bookmark</h6>
        <ul class="bookmark-dropdown">
          <li>
            <div class="row bookmark-scroll">
              @for (item of bookmarkItems; track item) {
                <div class="col-4 text-center">
                  <div class="bookmark-content">
                    <a [routerLink]="item?.path" routerLinkActive="item?.active">
                      <div class="bookmark-icon">
                        <app-svg-icon [icon]="item?.icon"></app-svg-icon>
                      </div>
                      <span>{{ item.title }}</span>
                    </a>
                  </div>
                </div>
              }
            </div>
          </li>
        </ul>

        <button (click)="flipBookMark()" class="flip-btn f-w-700" id="flip-btn">Add New Bookmark</button>


      </div>
      <div class="back">
        <ul>
          <li>
            <div class="bookmark-dropdown flip-back-content bookmark-wrapper">
              <input type="text" [(ngModel)]="text" [ngModelOptions]="{ standalone: true }" (keyup)="searchTerm(text)" placeholder="search..." />
              @if (menuItems?.length) {
                <div class="Typeahead-menu custom-scrollbar" [class.is-open]="searchResult" id="boomark-search-outer">
                  @for (item of menuItems | slice : 0 : 8; track item) {
                    <div class="ProfileCard u-cf">
                      <div class="ProfileCard-avatar">
                        <app-svg-icon [icon]="item?.icon"></app-svg-icon>
                      </div>
                      <div class="ProfileCard-details">
                        <div class="ProfileCard-realName d-flex">
                          <a [routerLink]="item?.path" (click)="removeFix()">{{ item?.title }}</a>
                          <button class="pull-right ms-auto" (click)="addToBookmark(item)" [attr.aria-label]="item.bookmark ? 'Remove from bookmarks' : 'Add to bookmarks'">
                            <i class="fa fa-star-o f-18" [class.starred]="item.bookmark"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              <div class="Typeahead-menu is-open" [class.is-open]="searchResultEmpty">
                <div class="tt-dataset tt-dataset-0">
                  <div class="EmptyMessage">Opps!! There are no result found.</div>
                </div>
              </div>
            </div>
          </li>
          <li><button (click)="flipBookMark()"
          class="f-w-700 d-block flip-back" id="flip-back">Back</button></li>

        </ul>
      </div>
    </div>
  </div>
</div>
